<template>
    <!--外层box-->
    <div  ref="diagram" :class="!isFull? 'diagram' : 'full'">
        <div v-if="ishow" ref="diagram" :class="!isFull? 'diagram' : 'full'">
            <div class="move-box">
                <iframe ref="iframe" id="iframes" style="width:100%;height:100%" :src="src" frameborder="0"></iframe>
            </div>
            <div class="pagecurr"  >
                <span>第{{index+1}}页/共{{wireList.length}}页</span>
                <div class="page"  @click="prev()"  :style="index==0?'opacity: 0.6;cursor: not-allowed;':''">上一页</div>
                <div class="page"  @click="next()" :style="(index+1)==wireList.length?'opacity: 0.6;cursor: not-allowed;':''">下一页</div>
                <div ref="container">
                <div  class="page" style="margin-left:16px" @click="show=!show">跳转</div>
                <div class="more" v-if="show"  >
                    <div v-for="(item,indexs) in wireList" :title="'第'+(indexs+1)+'页 '+item.name+''" class="item" :key="indexs" @click="checkItem(item,indexs)" :class="{active:index==indexs}">第{{indexs+1}}页&nbsp;&nbsp;&nbsp;{{item.name}}</div>
                </div>
                </div>
            </div>
            <div class="detail" @click="$emit('getDetailData')">
                <img src="@/assets/img/data.png" alt="">
                <div>电力数据</div>
            </div>
            <div class="tableContainer">
                <slot name="table" />
            </div>

            <div class="tableContainer">
                <slot name="loopDetail" />
            </div>

            <div class="btn row-center" v-if="!isFull" @click="full">
                <img src="@/assets/img/fullScreen1.png" alt="全屏">
                <span>全屏</span>
            </div>
            <div class="btn row-center" v-else @click="cancelFull">
                <img src="@/assets/img/full_cancel1.png" alt="取消全屏">
                <span>取消全屏</span>
            </div>
        <!-- <div class="helpContainer">
            <img src="@/assets/img/缩放.png" alt="缩放">
            <img src="@/assets/img/移动.png" alt="移动">
        </div> -->
        </div>
        <div v-else class="not_found_data">
            <img src="../../assets/img/not_found_data.png" alt="">
        </div>
    </div>
</template>

<script>
    
    import {
        GET_WireByProjectId
    } from '../../api/common'
    export default {
        name: "Diagram",
        props: {
            // src: String,
            areaId:String
        },
        data() {
            return {
                iframeWin: null,
                // 全屏
                isFull: false,
                wireList:[],
                src:"",
                index:0,
                show:false,
                ishow:true
            }
        },
        watch:{
            areaId(n,o){
                this.initData()
            },
           src(n,o){
                this.wireList.forEach((item,index)=>{
                    if(item.url==n){
                        this.index = index
                    }
                })
           }
        },
        beforeDestroy() {
            document.removeEventListener('mouseup', this.handle)
        },
        mounted() {
            window.addEventListener("message", this.handleMessage);
            this.iframeWin = this.$refs.iframe.contentWindow;


            this.initData();
            document.addEventListener('mouseup', this.handle)
        },
        methods: {
             handle(e) {    
                let tree = this.$refs.container
                if (tree) {
                    if (!tree.contains(e.target)) {
                        this.show = false
                    }
                }
            },
            checkItem(item,index){
                this.index = index
                this.src = this.wireList[this.index].url;
                this.show = !this.show
            },
            next(){
                if((this.index+1)==this.wireList.length){
                    return
                }
                this.index = this.index+1
                this.src = this.wireList[this.index].url
            },
            prev(){
                if(this.index==0){
                    return
                }
                this.index = this.index-1
                this.src = this.wireList[this.index].url
            },
            initData(){
                GET_WireByProjectId().then(res => {                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       
                    this.wireList = res.data.data.result.filter(e=>{return e.areaId == this.areaId})
                    if(this.wireList.length>0){
                        this.src=this.wireList[0].url
                        this.ishow = true
                    }else{
                        this.ishow = false
                    }
                    
                })
            },
            handleMessage(event) {
                console.log(event);
                const data = event.data;
                switch (data.cmd) {
                    case "SwitchingClosing":
                        this.$emit('loopDetail', data.cmd, data.loopName)
                        break;
                    case "RealTimeData":
                        this.$emit('loopDetail', data.cmd, data.loopName)
                        break;
                    case "CurrentDiagram":
                        this.src = data.src
                        break;

                }
            },
            full() {
                this.isFull = true
                this.$emit("onFull")
            },
            cancelFull() {
                this.isFull = false
                this.$emit("onCancelFull")
            },
        }
    }
</script>

<style scoped lang="less">
.not_found_data{
    text-align: center;
    padding-top: 15%;
    overflow: hidden;
}
.pagecurr{
    font-size: 18rem;
    position: absolute;
    top: 24rem;
    right: 24rem;
    z-index: 99;
    display: flex;
    align-items: center;
    font-size: 14px;
    .page{
        width: 64px;
        height: 24px;
        border: 1px dashed #333;
        display: inline-block;
        color: #333;
        text-align: center;
        line-height: 24px;
        margin-left: 8px;
        cursor: pointer;
    }
    span{
        color: #333;
    }
    .more{
        width: 144px;
        background: #fff;
        border-radius: 2px;
        position: absolute;
        right: 0;
        top: 40rem;
        border: 1px solid #ddd;
        border-bottom: 0;
        .item{
            border-bottom: 1px solid rgba(51, 51, 51, 0.15);
            height: 30px;
            line-height: 30px;
            padding: 0 9px;
            cursor: pointer;
            overflow: hidden;
            text-overflow: ellipsis;
            display: block;
            white-space: nowrap;
        }
        .active{
            color:#0D94FF;
        }
    }
}
    .full {
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        background-color: #ffffff;
    }

    .diagram {
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: relative;
        background-color: #ffffff;
    }

    .detail {
        font-size: 18rem;
        color: #333;
        position: absolute;
        top: 24rem;
        left: 24rem;
        z-index: 99;
        display: flex;
        align-items: center;
        cursor: pointer;

        img {
            width: 16rem;
            height: 19rem;
            margin-right: 8rem;
        }
    }

    .tableContainer {
        z-index: 99;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .move-box {
        width: 100%;
        height: 100%;
        position: relative;
        background-color: #fff;
    }

    .btn {
        position: absolute;
        bottom: 16px;
        right: 24px;
        z-index: 99;
        // color: #ffffff;
        font-size: 18rem;
        cursor: pointer;

        img {
            width: 16rem;
            margin-right: 6rem;
        }
    }

    .helpContainer {
        z-index: 99;
        position: absolute;
        right: 0;
        bottom: 0;
    }
</style>